import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M7 18.5h10m-10-3h10m-10-3h10m-2.5-10v5h5m0 0v14h-15v-19h10l5 5z" stroke="currentColor" fill="none" /></svg>;